import { ModelID, SearchParams, WorkOrder } from '@/types';

export type Filter = 'all';
export type Sort = 'created_at' | 'updated_at' | 'task_id' | 'name' | 'due_at' | 'meta->impact';
export interface WorkOrderSearchParams extends SearchParams<Filter, Sort>, Partial<WorkOrder> {
  parentOnly?: boolean;
  completed?: boolean;
}

export const featurePath = '/v4/tasks/work-orders';

export const featureKeys = {
  all: [{ scope: 'tasks', subscope: 'work-orders' }] as const,

  paged: (location: ModelID, search?: WorkOrderSearchParams) =>
    [{ ...featureKeys.lists(location)[0], entity: 'paged', search }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: WorkOrderSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
